import React from 'react';
import { AnimatedSection } from '../components/animated/AnimatedSection';
import { MagneticButton } from '../components/animated/MagneticButton';
import { useNavigate } from 'react-router-dom';
export function ProjectsPage() {
  const navigate = useNavigate();
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1253">
      <main className="flex-grow pt-20" data-id="element-1254">
        {/* Hero Section */}
        <section className="relative py-32 overflow-hidden" data-id="element-1255">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-green-50" data-id="element-1256" />
          <div className="absolute top-20 right-10 w-96 h-96 bg-green-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-1257" />

          <div className="container mx-auto px-6 lg:px-8 relative z-10" data-id="element-1258">
            <div className="max-w-4xl mx-auto text-center" data-id="element-1259">
              <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-gray-900 mb-8" data-id="element-1260">
                SkillzHQ{' '}
                <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent" data-id="element-1261">
                  Projects
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1262">
                Transforming People. Strengthening Institutions. Powering
                Africa's Future.
              </p>
              <p className="text-lg text-gray-600 mt-6 max-w-3xl mx-auto" data-id="element-1263">
                At SkillzHQ, we deliver high-impact projects that strengthen
                organisations, develop human capacity, and drive sustainable
                growth. Our work cuts across consulting, governance, talent
                solutions, organisational development, youth empowerment, and
                training.
              </p>
            </div>
          </div>
        </section>

        {/* Projects Content */}
        <div className="container mx-auto px-6 lg:px-8 py-16" data-id="element-1264">
          <div className="max-w-6xl mx-auto space-y-16" data-id="element-1265">
            {/* Project 1: Consulting & Governance Advisory */}
            <AnimatedSection data-id="element-1266">
              <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl p-8 md:p-12 border border-blue-100" data-id="element-1267">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1268">
                  1. Consulting & Governance Advisory
                </h2>

                <h3 className="text-2xl font-bold text-blue-600 mb-4" data-id="element-1269">
                  Governance & Organisational Structuring – Transall Nigeria
                  Limited
                </h3>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1270">
                  SkillzHQ led the development and setup of Transall Nigeria
                  Limited's, a legacy construction company's governance systems,
                  including:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-1271">
                  <li className="flex items-start text-gray-700" data-id="element-1272">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1273" />
                    Board and management governance structures
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1274">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1275" />
                    Delegation of authority framework
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1276">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1277" />
                    Compliance and reporting templates
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1278">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1279" />
                    Organisational policies to strengthen transparency,
                    performance, and accountability
                  </li>
                </ul>

                <p className="text-gray-700 italic" data-id="element-1280">
                  This intervention positioned Transall for sustainable growth
                  and improved operational discipline.
                </p>
              </div>
            </AnimatedSection>

            {/* Project 2: School Improvement */}
            <AnimatedSection data-id="element-1281">
              <div className="bg-gradient-to-br from-green-50 to-white rounded-3xl p-8 md:p-12 border border-green-100" data-id="element-1282">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-6" data-id="element-1283">
                  <div className="flex-1" data-id="element-1284">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1285">
                      2. School Improvement & Institutional Capacity Building
                    </h2>

                    <h3 className="text-2xl font-bold text-green-600 mb-4" data-id="element-1286">
                      School Improvement Training Programme – Igbinedion
                      Education Centre (IEC)
                    </h3>
                  </div>
                  <div className="flex-shrink-0" data-id="element-1287">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x5HzdRFRiiU5jujWeetW7H/Igbinedion_education_logo.jpg" alt="Igbinedion Education Centre" className="w-32 h-32 object-contain bg-white rounded-xl p-2 shadow-md" data-id="element-1288" />
                  </div>
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1289">
                  SkillzHQ delivered a bespoke 3-day School Improvement and
                  Leadership Training for Principals, Heads of Departments, and
                  over 150 teachers across IEC's campuses.
                </p>

                <h4 className="font-bold text-gray-900 mb-3" data-id="element-1290">
                  Key outcomes included:
                </h4>
                <ul className="space-y-3 mb-6" data-id="element-1291">
                  <li className="flex items-start text-gray-700" data-id="element-1292">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1293" />
                    Strengthened leadership and management skills
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1294">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1295" />
                    Improved classroom management, inclusion, and 21st-century
                    pedagogy
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1296">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1297" />
                    Strategic repositioning frameworks for the next 30 years
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1298">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1299" />
                    Comprehensive SWOT analysis and actionable change
                    initiatives
                  </li>
                </ul>

                <p className="text-gray-700 italic" data-id="element-1300">
                  The programme, commissioned by Her Excellency Lady Cherry
                  Igbinedion, set a new benchmark for staff alignment,
                  competence, and institutional renewal.
                </p>
              </div>
            </AnimatedSection>

            {/* Project 3: Youth Development */}
            <AnimatedSection data-id="element-1301">
              <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl p-8 md:p-12 border border-blue-100" data-id="element-1302">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 mb-6" data-id="element-1303">
                  <div className="flex-1" data-id="element-1304">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1305">
                      3. Youth Development & Skills Training
                    </h2>

                    <h3 className="text-2xl font-bold text-blue-600 mb-4" data-id="element-1306">
                      Soft Skills Training – Etin Power & Seplat JV Youth
                      Entrepreneurship Programme
                    </h3>
                  </div>
                  <div className="flex gap-4 flex-shrink-0" data-id="element-1307">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5ExF9dSNNjY5xmL3eXephQ/etinpower_logo.webp" alt="Etin Power" className="w-24 h-24 object-contain bg-white rounded-xl p-2 shadow-md" data-id="element-1308" />
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3uKVTGuMipqgm74dX6GJCG/Seplat_Logo_2_%281%29.jpg" alt="Seplat Energy" className="w-24 h-24 object-contain bg-white rounded-xl p-2 shadow-md" data-id="element-1309" />
                  </div>
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1310">
                  SkillzHQ delivered high-impact soft skills and
                  employability-focused sessions for youth in the South/South
                  region of Nigeria, selected for the Seplat Youth
                  Entrepreneurship Programme, commissioned to SkillzHQ by
                  EtinPower, training young entrepreneurs across three modules:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-1311">
                  <li className="flex items-start text-gray-700" data-id="element-1312">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1313" />
                    An Introduction to Entrepreneurship (SIE 101)
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1314">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1315" />
                    Growth Mindset (SGM 101)
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1316">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1317" />
                    Introduction to Financial Literacy (SIFL 101)
                  </li>
                </ul>

                <p className="text-gray-700 italic" data-id="element-1318">
                  Using experiential learning, case studies, role-plays, and
                  reflective exercises, participants gained practical tools to
                  launch and scale ventures. The programme received outstanding
                  feedback for its relevance and interactive delivery, with
                  recommendations for ongoing mentorship and post-training
                  impact tracking.
                </p>
              </div>
            </AnimatedSection>

            {/* Project 4: Recruitment */}
            <AnimatedSection data-id="element-1319">
              <div className="bg-gradient-to-br from-green-50 to-white rounded-3xl p-8 md:p-12 border border-green-100" data-id="element-1320">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1321">
                  4. Recruitment & Talent Solutions
                </h2>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1322">
                  We support organisations to hire and retain exceptional talent
                  through a rigorous, data-driven recruitment process.
                </p>

                <h4 className="font-bold text-gray-900 mb-4" data-id="element-1323">
                  SkillzHQ has successfully recruited for leading African
                  companies including:
                </h4>

                <div className="space-y-6" data-id="element-1324">
                  <div data-id="element-1325">
                    <h5 className="font-bold text-green-600 mb-2" data-id="element-1326">Venco</h5>
                    <p className="text-gray-700" data-id="element-1327">
                      End-to-end recruitment for key technical and operational
                      roles to support Venco's expansion.
                    </p>
                  </div>

                  <div data-id="element-1328">
                    <h5 className="font-bold text-green-600 mb-2" data-id="element-1329">Shuttlers</h5>
                    <p className="text-gray-700" data-id="element-1330">
                      Sourcing, talent mapping, and selection support for roles
                      central to Shuttlers' mobility and technology operations.
                    </p>
                  </div>

                  <div data-id="element-1331">
                    <h5 className="font-bold text-green-600 mb-2" data-id="element-1332">
                      Zarein Energy
                    </h5>
                    <p className="text-gray-700" data-id="element-1333">
                      Energy sector recruitment solutions covering technical,
                      project, and administrative positions.
                    </p>
                  </div>

                  <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-1334">
                    <div className="flex-1" data-id="element-1335">
                      <h5 className="font-bold text-green-600 mb-2" data-id="element-1336">
                        Terra Academy for The Arts (TAFTA)
                      </h5>
                      <p className="text-gray-700" data-id="element-1337">
                        Large-scale recruitment of facilitators, programme
                        personnel, and state representatives for TAFTA's
                        creative economy programmes.
                      </p>
                    </div>
                    <div className="flex-shrink-0" data-id="element-1338">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/52iTPEo5oYqgbDuSsj45eL/TAFTA-LOGO-1.jpg" alt="TAFTA" className="w-24 h-24 object-contain bg-white rounded-xl p-2 shadow-md" data-id="element-1339" />
                    </div>
                  </div>

                  <div data-id="element-1340">
                    <h5 className="font-bold text-green-600 mb-2" data-id="element-1341">EtinPower</h5>
                    <p className="text-gray-700" data-id="element-1342">
                      Talent acquisition support for administrative, technical,
                      and programme positions.
                    </p>
                  </div>

                  <div data-id="element-1343">
                    <h5 className="font-bold text-green-600 mb-2" data-id="element-1344">
                      Tech Startups (Portfolio)
                    </h5>
                    <p className="text-gray-700 mb-3" data-id="element-1345">
                      SkillzHQ has built talent pipelines for multiple
                      early-stage and growth-stage startups across:
                    </p>
                    <ul className="space-y-2 ml-6" data-id="element-1346">
                      <li className="flex items-start text-gray-700" data-id="element-1347">
                        <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1348" />
                        Product & engineering
                      </li>
                      <li className="flex items-start text-gray-700" data-id="element-1349">
                        <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1350" />
                        Operations & growth
                      </li>
                      <li className="flex items-start text-gray-700" data-id="element-1351">
                        <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1352" />
                        Customer success
                      </li>
                      <li className="flex items-start text-gray-700" data-id="element-1353">
                        <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1354" />
                        Finance & HR
                      </li>
                    </ul>
                  </div>
                </div>

                <p className="text-gray-700 italic mt-6" data-id="element-1355">
                  Our talent work helps startups hire fast, hire right, and
                  scale sustainably.
                </p>
              </div>
            </AnimatedSection>

            {/* Project 5: Corporate Training */}
            <AnimatedSection data-id="element-1356">
              <div className="bg-gradient-to-br from-blue-50 to-white rounded-3xl p-8 md:p-12 border border-blue-100" data-id="element-1357">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1358">
                  5. Corporate Training & Learning Programmes
                </h2>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1359">
                  SkillzHQ designs and delivers tailored training programmes
                  that empower people and accelerate organisational performance.
                  We have developed and deployed programmes across:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-1360">
                  <li className="flex items-start text-gray-700" data-id="element-1361">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1362" />
                    Leadership development
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1363">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1364" />
                    Customer experience
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1365">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1366" />
                    Critical thinking
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1367">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1368" />
                    Workplace ethics
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1369">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1370" />
                    Digital skills
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1371">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1372" />
                    Team effectiveness & culture alignment
                  </li>
                </ul>

                <p className="text-gray-700 italic" data-id="element-1373">
                  All training integrates 21st-century learning design and
                  measurable outcomes.
                </p>
              </div>
            </AnimatedSection>

            {/* Project 6: Social Impact */}
            <AnimatedSection data-id="element-1374">
              <div className="bg-gradient-to-br from-green-50 to-white rounded-3xl p-8 md:p-12 border border-green-100" data-id="element-1375">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1376">
                  6. Social Impact & Creative Economy Projects
                </h2>

                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1377">
                  Through strategic partnerships with brands like 3MTT through
                  Edojobs, GIZ, we have supported youth empowerment,
                  entrepreneurship, and community development initiatives
                  including:
                </p>

                <ul className="space-y-3 mb-6" data-id="element-1378">
                  <li className="flex items-start text-gray-700" data-id="element-1379">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1380" />
                    Creative arts training
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1381">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1382" />
                    Mentorship and coaching
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1383">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1384" />
                    Employability bootcamps
                  </li>
                  <li className="flex items-start text-gray-700" data-id="element-1385">
                    <span className="w-1.5 h-1.5 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1386" />
                    Community capacity-building projects
                  </li>
                </ul>

                <p className="text-gray-700 italic" data-id="element-1387">
                  Our programmes prioritize women and young people ensuring
                  inclusive access to skills and economic opportunity.
                </p>
              </div>
            </AnimatedSection>

            {/* Our Impact */}
            <AnimatedSection data-id="element-1388">
              <div className="bg-gradient-to-br from-blue-600 to-green-600 rounded-3xl p-8 md:p-12 text-white" data-id="element-1389">
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1390">
                  Our Impact
                </h2>

                <p className="text-blue-100 mb-6 leading-relaxed" data-id="element-1391">
                  Across all projects, SkillzHQ continues to:
                </p>

                <ul className="space-y-3 mb-8" data-id="element-1392">
                  <li className="flex items-start" data-id="element-1393">
                    <span className="w-1.5 h-1.5 bg-white rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1394" />
                    Institutional strengthening
                  </li>
                  <li className="flex items-start" data-id="element-1395">
                    <span className="w-1.5 h-1.5 bg-white rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1396" />
                    Equipping young Africans with future-ready skills
                  </li>
                  <li className="flex items-start" data-id="element-1397">
                    <span className="w-1.5 h-1.5 bg-white rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1398" />
                    Building talent pipelines for African businesses
                  </li>
                  <li className="flex items-start" data-id="element-1399">
                    <span className="w-1.5 h-1.5 bg-white rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1400" />
                    Driving organisational excellence, mindset and culture
                    transformation
                  </li>
                  <li className="flex items-start" data-id="element-1401">
                    <span className="w-1.5 h-1.5 bg-white rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-1402" />
                    Support partners in delivering sustainable impact
                  </li>
                </ul>

                <p className="text-2xl font-semibold mb-4" data-id="element-1403">
                  Ready to elevate your people and performance? Let's talk.
                </p>

                <MagneticButton variant="secondary" size="lg" onClick={() => navigate('/contact')} data-id="element-1404">
                  Get in Touch
                </MagneticButton>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </main>
    </div>;
}